module.exports = __webpack_public_path__ + "img/travel-insurance-feature.634832a.png";